const ShowtimesDateSwiper = () => {

  let dateEl;

  const initSwiper = () => {
    dateEl = document.querySelector('swiper-container.showtimes-date-swiper');
    if (dateEl) {
      const params = {
        observer: true,
        observeParents: true,
        injectStyles: [`
          .swiper-scrollbar-drag {
              background: var(--page-theme);
          }
          .swiper {
              overflow: visible;
          }
        `],
        scrollbar: {
          draggable: true,
          hide: false,
        },
        keyboard: {
          enabled: true,
        },
        freeMode: true,
        slidesPerView: 'auto',
      };

      Object.assign(dateEl, params);
      dateEl.initialize();
    }
  };

    document.addEventListener("DOMContentLoaded", () => {
      initSwiper();
    });

    if (document.querySelector(".showtimes-date-swiper")) {
      if (document.querySelector(".showtimes-date-swiper").shadowRoot.querySelector(".swiper-scrollbar-drag")) {
        document.querySelector(".showtimes-date-swiper").shadowRoot.querySelector(".swiper-scrollbar-drag").style.backgroundColor = "var(--secondary)";
      }
    }

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    const updateSwiper = () => {
      if (dateEl && typeof dateEl.update === "function") {
        dateEl.update();
      }
    };
    
    window.addEventListener('resize', debounce(() => {
      // Use requestAnimationFrame to ensure the DOM has updated
      requestAnimationFrame(updateSwiper);
    }, 300));

};

export default ShowtimesDateSwiper;